exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd[data-v-29203a2a] {\n    vertical-align: top;\n}\n", ""]);

// exports
